import { render, staticRenderFns } from "./LeadershipBadgeIcon.vue?vue&type=template&id=05188ff4"
import script from "./LeadershipBadgeIcon.vue?vue&type=script&lang=js"
export * from "./LeadershipBadgeIcon.vue?vue&type=script&lang=js"
import style0 from "./LeadershipBadgeIcon.vue?vue&type=style&index=0&id=05188ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports